import { useState } from "react";
import { auth, googleProvider } from "../firebase";
import { signInWithPopup } from "firebase/auth";

function Login({ setUser }) {
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    try {
      setLoading(true);

      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const userData = {
        uid: user.uid,
        name: user.displayName,
        email: user.email,
      };

      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);
    } catch (err) {
      console.error(err);
      alert("Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleLogin}
      disabled={loading}
      className={`glass glass-hover flex items-center gap-3 px-5 py-2 rounded-xl transition ${
        loading ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      {/* Google Icon */}
      <img
        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
        alt="google"
        className="w-5 h-5"
      />

      <span className="text-sm text-gray-200">
        {loading ? "Signing in..." : "Continue with Google"}
      </span>
    </button>
  );
}

export default Login;